@use 'sass:map';
@import '../../themes/capsule.globals';

:host {
  position: fixed;
  width: 100%;
  height: 100%;
  inset: 0px;

  z-index: map.get($z-indices, 'overlay');

  opacity: 0%;
  display: none;

  background: var(--cpsl-overlay-background, linear-gradient(180deg, rgba(0, 0, 0, 0.14) 0%, rgba(0, 0, 0, 0.7) 100%));
}

:host(.over-modal) {
  z-index: map.get($z-indices, 'modal');
}
